import { render, staticRenderFns } from "./ApplyLevel2Dialog.vue?vue&type=template&id=10783080&scoped=true"
import script from "./ApplyLevel2Dialog.vue?vue&type=script&lang=js"
export * from "./ApplyLevel2Dialog.vue?vue&type=script&lang=js"
import style0 from "./ApplyLevel2Dialog.vue?vue&type=style&index=0&id=10783080&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10783080",
  null
  
)

export default component.exports